export default __webpack_public_path__ + "static/media/future-blue.bf1e8b44.svg";